import { render, staticRenderFns } from "./SEmptyState.vue?vue&type=template&id=2bd27537&scoped=true&lang=pug"
import script from "./SEmptyState.vue?vue&type=script&setup=true&lang=ts"
export * from "./SEmptyState.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SEmptyState.vue?vue&type=style&index=0&id=2bd27537&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd27537",
  null
  
)

export default component.exports